import React from 'react';
import Carte from '../ui/Carte';
import ChampTexte from '../champs/ChampTexte';

function SectionPaiement({ phases, fraisDossier, conditionsPaiement, onChangerConditionsPaiement }) {
  const montantFrais = parseFloat(fraisDossier) || 0;
  const sousTotal = phases.reduce((acc, phase) => {
    const jeh = parseFloat(phase.nombreJeh) || 0;
    const prix = parseFloat(phase.prixUnitaire) || 0;
    return acc + jeh * prix;
  }, 0);

  const montantHT = montantFrais + sousTotal;
  const montantTTC = montantHT * 1.2;

  const pctSignature = parseFloat(conditionsPaiement.pctSignature) || 0;
  const pctLivrable = parseFloat(conditionsPaiement.pctLivrable) || 0;
  const ratioSignature = pctSignature / 100;
  const ratioLivrable = pctLivrable / 100;

  const formaterEuro = (val) =>
    val.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  return (
    <Carte titre="Conditions de paiement indicatives" icone="💳">
      <div className="grille grille--2col" style={{ marginBottom: 20 }}>
        <ChampTexte
          label="À la signature (%)"
          valeur={conditionsPaiement.pctSignature}
          onChange={onChangerConditionsPaiement}
          nom="pctSignature"
          placeholder="55"
          chiffresUniquement
          maxLength={3}
          infobulle="Le solde est calculé automatiquement pour totaliser 100 %"
        />
        <ChampTexte
          label="À la remise du livrable final (%)"
          valeur={conditionsPaiement.pctLivrable}
          onChange={onChangerConditionsPaiement}
          nom="pctLivrable"
          placeholder="45"
          chiffresUniquement
          maxLength={3}
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <div style={{ padding: '16px', background: 'var(--bleu-clair)', borderRadius: 'var(--rayon)', fontSize: 13 }}>
          <div style={{ color: 'var(--gris-texte)', fontSize: 12, marginBottom: 4 }}>
            À la signature {pctSignature} %
          </div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>{formaterEuro(montantTTC * ratioSignature)} TTC indicatif</div>
          <div style={{ color: 'var(--gris-texte)', fontSize: 12 }}>{formaterEuro(montantHT * ratioSignature)} HT</div>
        </div>
        <div style={{ padding: '16px', background: 'var(--bleu-clair)', borderRadius: 'var(--rayon)', fontSize: 13 }}>
          <div style={{ color: 'var(--gris-texte)', fontSize: 12, marginBottom: 4 }}>
            À la remise du livrable final {pctLivrable} %
          </div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>{formaterEuro(montantTTC * ratioLivrable)} TTC indicatif</div>
          <div style={{ color: 'var(--gris-texte)', fontSize: 12 }}>{formaterEuro(montantHT * ratioLivrable)} HT</div>
        </div>
      </div>
    </Carte>
  );
}

export default SectionPaiement;
